/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-template-curly-in-string */

// Configuração de localização para Yup 1.x
export const yupBrazilianLocale = {
  mixed: {
    default: 'Inválido',
    required: 'Obrigatório',
    oneOf: 'Deve ser um dos valores: ${values}',
    notOneOf: 'Não deve ser um dos valores: ${values}',
    notType: 'Deve ser do tipo ${type}',
    defined: 'Deve ser definido',
  },
  string: {
    length: 'Deve ter exatamente ${length} caracteres',
    min: 'Deve ter pelo menos ${min} caracteres',
    max: 'Deve ter no máximo ${max} caracteres',
    matches: 'Deve corresponder ao padrão: "${regex}"',
    email: 'Deve ser um e-mail válido',
    url: 'Deve ser uma URL válida',
    uuid: 'Deve ser um UUID válido',
    trim: 'Não deve conter espaços no início ou fim',
    lowercase: 'Deve estar em minúsculo',
    uppercase: 'Deve estar em maiúsculo',
  },
  number: {
    min: 'Deve ser maior ou igual a ${min}',
    max: 'Deve ser menor ou igual a ${max}',
    lessThan: 'Deve ser menor que ${less}',
    moreThan: 'Deve ser maior que ${more}',
    positive: 'Deve ser um número positivo',
    negative: 'Deve ser um número negativo',
    integer: 'Deve ser um número inteiro',
  },
  date: {
    min: 'Deve ser posterior a ${min}',
    max: 'Deve ser anterior a ${max}',
  },
  boolean: {
    isValue: 'Deve ser ${value}',
  },
  object: {
    noUnknown: 'Não deve ter chaves não especificadas: ${unknown}',
  },
  array: {
    min: 'Deve ter pelo menos ${min} itens',
    max: 'Deve ter no máximo ${max} itens',
    length: 'Deve ter exatamente ${length} itens',
  },
};

export default yupBrazilianLocale;
